module.exports = __webpack_public_path__ + "static/faith-howley-audio-showreel-19561c89f43502a554f1332589e2ef2f.mp3";